// extracted by mini-css-extract-plugin
export default {"mainWrraper":"style_mainWrraper__0rEBc","saveAndQuitImg":"style_saveAndQuitImg__4ekE7"};